import React, { memo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@web/theme';
import { AccountProvider, AuthProvider, BlocksProvider, PageProvider, PagesProvider, SettingsProvider } from '../';
import { FirebaseProvider } from '@web/firebase';
export var GlobalProviders = memo(function (_a) {
    var theme = _a.theme, firebaseConfig = _a.firebaseConfig, firebaseUIConfig = _a.firebaseUIConfig, name = _a.name, children = _a.children;
    return (React.createElement(FirebaseProvider, { config: firebaseConfig, uiConfig: firebaseUIConfig, name: name },
        React.createElement(BrowserRouter, null,
            React.createElement(AuthProvider, null,
                React.createElement(SettingsProvider, null,
                    React.createElement(AccountProvider, null,
                        React.createElement(ThemeProvider, { value: { theme: theme } },
                            React.createElement(PagesProvider, null,
                                React.createElement(PageProvider, null,
                                    React.createElement(BlocksProvider, null, children))))))))));
});
